<!--工作室课程-->
<template>
    <div class="studio_nav_content">
        <!--列表模式-->
        <div class="page-mode" v-show="showMode==='page'">
            <!-- 搜索条件 -->
            <div class="form-box">
                <el-form ref="queryForm"
                         :model="queryParams"
                         :inline="true"
                         label-width="40px">
                    <el-row class="mt10 ml10" >
                        <el-col :span="4" class="mb0">
                            <el-form-item label="学段">
                                <el-select clearable @change="changePeriod" v-model="queryParams.periodKey" placeholder="请选择">
                                    <el-option v-for="item in periodList" :key="item.dictKey" :label="item.dictValue"
                                               :value="item.dictKey" />
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="4" class="mb0">
                            <el-form-item label="年级">
                                <el-select clearable @change="changeGrade" v-model="queryParams.gradeKey" placeholder="请选择">
                                    <el-option v-for="item in gradeList" :key="item.dictKey" :label="item.dictValue"
                                               :value="item.dictKey" />
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="4" class="mb0">
                            <el-form-item label="学科">
                                <el-select clearable @change="pageCourse(null)" v-model="queryParams.subjectKey" placeholder="请选择">
                                    <el-option v-for="item in subjectList" :key="item.dictKey" :label="item.dictValue"
                                               :value="item.dictKey" />
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6" class="mr0 mb0"></el-col>
                        <el-col :span="6" class="mr0 mb0">
                            <el-form-item class="pull-right">
                                <el-input v-model="queryParams.courseName" placeholder="请输入课程名称" class="input-with-select">
                                    <template #append>
                                        <el-button type="primary" @click="pageCourse(null)" style="background-color: #ff7f2e;color: #fff" icon="el-icon-search" />
                                    </template>
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
            <div class="right-container">
                <div class="page-info-container">
                    <div class="info-list-container">
                        <div class="course-list-box">
                            <div class="course-item" v-for="item in dataList" :key="item">
                                <el-card @click="viewCourse(item)" :body-style="{ padding: '0px' }" class="course-one">
                                    <div class="course-name">{{item.courseName}}</div>
                                    <div class="course-info">
                                        <div class="course-cover">
                                            <img class="img-100" :src="item.courseCover" alt />
                                        </div>
                                        <div class="course-title">
                                            <div class="course-subject">{{item.periodName}}-{{item.gradeName}}-{{item.subjectName}}</div>
                                            <div class="course-subject">主讲人：{{item.userName?item.userName:'--'}}</div>
                                            <div class="course-subject">课程类型：{{title}}</div>
                                            <div class="course-stats">
                                                <div class="stpBox">
                                                    <img class="mr3"  style="width: 16px;height:16px" src="../../assets/image/dz.png" alt>
                                                    {{ item.likeCount }}
                                                </div>
                                                <div class="stpBox">
                                                    <el-icon class="mr3">
                                                        <Star/>
                                                    </el-icon>
                                                    {{ item.collectCount }}
                                                </div>
                                                <div class="stpBox">
                                                    <el-icon class="mr3">
                                                        <View/>
                                                    </el-icon>
                                                    {{ item.viewCount }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </el-card>
                            </div>
                        </div>
                        <data-empty v-if="dataList&&dataList.length===0" title="暂无数据"/>
                    </div>
                    <div class="page-container" v-if="dataList&&dataList.length>0">
                        <pageTag :background="true"
                                 :pageSizes="[6, 9, 12]"
                                 v-show="total > 0"
                                 :total="total"
                                 v-model:page.sync="queryParams.pageNum"
                                 v-model:limit.sync="queryParams.pageSize"
                                 @pagination="pageCourse" />
                    </div>
                </div>
            </div>
        </div>
        <!--详情模式-->
        <div class="detail-mode" v-if="showMode==='detail'">
            <course-info :course-id="this.courseId" :classify="courseType"
                         @change-mode="changeModel"/>
        </div>


    </div>
</template>

<script>
import dataEmpty from "@/components/dataEmpty.vue";
import pageTag from "@/components/Pagination/page.vue";
import courseInfo from "@/components/course/courseInfo.vue";
import {timestampDate} from "@/utils/date";
import {famousCoursePageFamousCourses} from "@/api/admin/famousCourse";
import {queryDict} from "@/api/admin/public";

export default {
    name:'pageCourse',
    components:{pageTag, dataEmpty,courseInfo},
    props:{
        title:{
            type: String,
            default:null
        },
        courseType:{
            type: String,
            default:null
        },
        courseMode:{
            type: String,
            default:'page'
        },
        parentId:{
            type: String,
            default:''
        }
    },
    watch:{
        courseMode(newValue,oldValue){
            this.showMode = newValue;
        },
        parentId(newValue,oldValue){
            this.courseId = newValue;
        },
    },
    mounted() {
        if (this.$store.state.params.jumpParams.courseId){
            this.courseId = this.$store.state.params.jumpParams.courseId;
            this.showMode = "detail"
            this.$emit('change-mode',this.showMode);
        }
        this.getQueryDict();
        this.pageCourse();
    },
    data() {
        return {
            showMode:'page',
            timestampDate,
            itemName:'高水平示范课',
            itemKey:'',
            queryParams: {
                pageNum: 1,
                pageSize: 6,
                stageType: '',
                periodKey: '',
                gradeKey: '',
                subjectKey: '',
                courseName:'',
                courseType:1
            },
            total: 0,
            pageCount:0,
            dataList: [],
            studioClassifyList:[],
            courseId:'',
            periodList: [],
            gradeList: [],
            subjectList: [],
        }
    },
    methods: {
        getQueryDict() {
            queryDict({ code: 'lession_xd_nj_xk' }).then(res => {
                this.periodList = res.data.data;
            })
        },
        changePeriod() {
            this.queryParams.gradeKey = '';
            this.queryParams.subjectKey = '';
            this.gradeList = [];
            this.subjectList = [];
            this.periodList.forEach(j => {
                if (this.queryParams.periodKey === j.dictKey) {
                    this.gradeList = j.childrenList;
                }
            })
            this.pageCourse()
        },
        changeGrade() {
            this.queryParams.subjectKey = '';
            this.subjectList = []
            this.periodList.forEach(e => {
                if (this.queryParams.periodKey === e.dictKey) {
                    e.childrenList.forEach(j => {
                        if (this.queryParams.gradeKey === j.dictKey) {
                            this.subjectList = j.childrenList;
                        }
                    })
                }
            })
            this.pageCourse()
        },
        pageCourse(){
            this.queryParams.stageType = this.courseType;
            this.queryParams.groupId = this.studioId
            famousCoursePageFamousCourses(this.queryParams).then(res => {
                if (res.data.code === 1) {
                    this.dataList = res.data.data.list;
                    this.total = res.data.data.total;
                    this.pageCount = res.data.data.totalPage;
                }else {
                    this.$message.error("请求出错")
                }
            })
        },
        viewCourse(item){
            debugger
            if (item.isAuth&&item.isAuth === 1){
                this.showMode = "detail"
                this.courseId = item.courseId;
                this.$emit('change-mode',this.showMode);
            }else {
                this.$message.info("暂无权限观看")
            }

        },
        changeModel(item){
            this.showMode = item
            this.$emit('change-mode',this.showMode, 5);
        },
    }
}

</script>

<style scoped>
.studio_nav_content{
    width: 100%;
    height: auto;
}
.page-mode{
    width: 100%;
    height: calc(100vh - 90px);
    background-color: #fff;
}
.form-box{
    width: 100%;
    height: 50px;
    margin: auto;
    border-bottom: 2px solid #ff7f2e;
    background-color: #fff;
    padding-top: 5px;
}
.right-container{
    width: 100%;
    height: auto;
}
.page-info-container{
    width: 100%;
    height: auto;
    padding-bottom: 10px;
    background-color: #fff;
}
.info-top-title{
    width: 99%;
    height: 34px;
    margin: auto;
    line-height: 30px;
    font-size: 16px;
    font-weight: 400;
    display: flex;
    flex-direction: column;
}
.title{
    padding-right: 10px;
    border-bottom: 2px solid #ff7f2e;
}

.info-list-container{
    width: 100%;
    height: calc(100vh - 210px)!important;
    margin: auto;
    overflow-x: hidden;
}
/*课程*/
.course-list-box{
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    height: auto;
    padding-left: 4px;
    padding-bottom: 10px;
    align-items: center;
}
.course-item{
    width: 33.3%!important;
    height: 190px;
    padding: 10px;
    box-sizing: border-box;
}
.course-one{
    width: 100%;
    height: 100%;
    padding: 10px;
    border-radius: 4px;
    box-sizing: border-box;
    cursor: pointer;
}
.course-info{
    display: flex;
    width: 100%;
    height: 120px;
}
.course-cover{
    width: 50%;
    height: 100%;
    box-shadow: var(--el-box-shadow-light);
    img{
        width: 100%;
        height: 100%;
    }
}
.course-title{
    width: 50%;
    height: 100%;
}
.course-name{
    box-sizing: border-box;
    font-size: 16px;
    color: #333333;
    font-weight: bold;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    height: 30px;
}
.course-subject{
    padding-left: 10px;
    box-sizing: border-box;
    font-size: 14px;
    color: #333333;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    height: 30px;
    //line-height: 30px;
}
.course-commend{
    padding-left: 10px;
    padding-top: 2px;
    box-sizing: border-box;
    font-size: 14px;
    color: #333333;
    height: 60px;
    line-height: 20px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    word-break: break-all;
}
.course-stats{
    width: 100%;
    height: 30px;
    padding-left: 10px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-around;
    align-items: center;
}
.stpBox {
    width: 33.3%;
    display: flex;
    align-items: center;
    cursor: pointer;
    font-size: 15px;
}
.page-container{
    display: grid;
    place-items: center;
    width: 98%;
    height: 40px;
    padding-top: 15px;
    box-sizing: border-box;
}
.detail-mode{
    width: 100%;
    height: auto;
}
</style>